<!-- 导师确认 -->
<template>
  <div class="confirm">
    <div class="confirm-detail">
      <zlr-progress :percent="progress0"></zlr-progress>
      <div class="confirm-detail-item">
        <h1>
          Please confirm the time
          <span>The latest respond time: {{ appDetail.createTime | addTwoDay}} (Beijing Time)</span>
        </h1>
        <ul class="confirm-proposed">
          <li>Mentee proposed time ( {{appDetail.menteeZone | zoneTitleMap}})</li>
          <li v-for="(item,index) in menteeZoneList"
              :key="index">{{item.minTimeStr}} - {{item.maxTimeStr}} {{index === 0 ? '(priority)': ''}}</li>
        </ul>
        <div class="confirm-item">
          <div class="confirm-item-title">1. Please select your current time zone</div>
          <div>
            <Select v-model="formData.mentorZone"
                    placeholder="Select"
                    @on-change="zoneChange">
              <Option v-for="(item,index) in zone"
                      :value="item.value"
                      :key="index">{{item.title}}</Option>
            </Select>
          </div>
        </div>
        <div class="confirm-item dis-0"
             :class="{'zlr-cover': !formData.mentorZone}">
          <div class="confirm-item-title">2. Please confirm if one of the proposed times above is OK</div>
          <div class="confirm-item-ok">
            <span :class="{'active': formData.isOK === 1}"
                  @click="selOkChange(1)">OK</span>
            <span :class="{'active': formData.isOK === 0}"
                  @click="selOkChange(0)">Not OK</span>
          </div>
        </div>
      </div>
    </div>
    <div class="confirm-ok"
         v-if="formData.isOK === 1">
      <zlr-progress :percent="progress1"></zlr-progress>
      <div class="confirm-content">
        <div>
          <h2>Proposed time is ok</h2>
          <div class="confirm-item">
            <div class="confirm-item-title">1. Please select mentee expectation</div>
            <div class="confirm-item-ok">
              <span v-for="(item, index) in zoneList"
                    :key="index"
                    :class="{'active': expectRange[0] === item.minTimeStr && expectRange[1] === item.maxTimeStr}"
                    @click="expectTimeHandle(item)">{{`${item.minTimeStr} - ${item.maxTimeStr}`}}</span>
            </div>
          </div>
          <div class="confirm-item"
               :class="{'zlr-cover': !(expectRange[0] && expectRange[1])}">
            <div class="confirm-item-title">2. Please select time point</div>
            <div style="display:flex;  justify-content: space-between;">
              <DatePicker placeholder="Select date and time"
                          type="date"
                          v-model="formData.resultTimeStrStart"
                          style="width:360px;"></DatePicker>
              <TimePicker type="time"
                          placeholder="Select time"
                          format="HH:mm"
                          :steps="[1, 5]"
                          v-model="formData.resultTimeStrEnd"
                          style="width:360px;"></TimePicker>
            </div>
            <div v-show="!!errorMsg"
                 class="confirm-item-error">
              {{ errorMsg }}
            </div>
            <div class="confirm-btn">
              <Button class="zlr-btn-primary"
                      @click="okSubHandle"
                      :loading="isSub">Confirm</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="confirm-notok"
         v-if="formData.isOK === 0">
      <zlr-progress :percent="progress1"></zlr-progress>
      <div class="confirm-content">
        <div>
          <h2>Mentee’s proposed time is not ok</h2>
          <div class="confirm-item ">
            <div class="confirm-item-title">1. Please select you preferred time (Most preferred)</div>
            <div class="confirm-item-time">
              <div>
                <DatePicker type="date"
                            placeholder="Select date"
                            style="width:100%;"
                            :options="optionsTime"
                            v-model="formData.timeContent[0][0]"></DatePicker>
              </div>
              <div>
                <TimePicker type="timerange"
                            placeholder="Select time"
                            style="width:100%;"
                            format="HH:mm"
                            :steps="[1, 10]"
                            v-model="formData.timeContent[0][1]"></TimePicker>
              </div>
            </div>
          </div>
          <div class="confirm-item">
            <div class="confirm-item-title">2. Please select you expectation</div>
            <div class="confirm-item-time">
              <div>
                <DatePicker type="date"
                            placeholder="Select date"
                            style="width:100%;"
                            :options="optionsTime"
                            v-model="formData.timeContent[1][0]"></DatePicker>
              </div>
              <div>
                <TimePicker type="timerange"
                            placeholder="Select time"
                            style="width:100%;"
                            format="HH:mm"
                            :steps="[1, 10]"
                            v-model="formData.timeContent[1][1]"></TimePicker>
              </div>
            </div>
          </div>
          <div class="confirm-item" v-if="isAddTimeContent">
            <div class="confirm-item-title">3. Please select you expectation</div>
            <div class="confirm-item-time">
              <div>
                <DatePicker type="date"
                            placeholder="Select date"
                            style="width:100%;"
                            :options="optionsTime"
                            v-model="formData.timeContent[2][0]"></DatePicker>
              </div>
              <div>
                <TimePicker type="timerange"
                            placeholder="Select time"
                            style="width:100%;"
                            format="HH:mm"
                            :steps="[1, 10]"
                            v-model="formData.timeContent[2][1]"></TimePicker>
              </div>
            </div>
          </div>
          <div class="dis-0">
            <div><Button @click="chanbgeAddTimeContent">{{!isAddTimeContent?'Add you expectation time':'Delete you expectation time'}}</Button></div>
          </div>
          <div class="confirm-btn">
            <Button class="zlr-btn-primary"
                    @click="notOkHandle"
                    :loading="isSub">Confirm</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { subAppConfirm, getAppTimeZone } from '@/api/appointment'
// components
import ZlrProgress from '_c/progress/progress'
// constant
import { zone } from '@/constant/mentor'
import { subSuc } from '@/constant'
import dayjs from 'dayjs'
export default {
  name: 'mentee-confirm-time',
  props: ['appDetail'],
  components: {
    ZlrProgress
  },
  data () {
    return {
      progress0: 0,
      progress1: 0,
      zone,
      optionsTime: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      appointmentId: this.$route.query.id,
      formData: {
        timeContent: [[], [], []]
      },
      errorMsg: '',
      zoneList: [],
      menteeZoneList: [],
      expectRange: [],
      isSub: false,
      isAddTimeContent: false
    }
  },
  mounted () {
    this.getMenteeZone()
  },
  methods: {
    // ok 提交信息
    okSubHandle () {
      this.errorMsg = ''
      let data = JSON.parse(JSON.stringify(this.formData))
      if (!data.resultTimeStrStart || !data.resultTimeStrEnd) {
        this.errorMsg = 'Please confirm appointment'
        return false
      }
      data.resultTimeStr = dayjs(data.resultTimeStrStart).format('YYYY-MM-DD') + ' ' + data.resultTimeStrEnd
      let time = dayjs(data.resultTimeStr).valueOf()
      let minTime = dayjs(this.expectRange[0]).valueOf()
      let maxTime = dayjs(this.expectRange[1]).valueOf()
      if (time < minTime || time > maxTime) {
        this.errorMsg = 'Please select the right time'
        return false
      }
      data.resultTimeStr = dayjs(data.resultTimeStr).format('YYYY-MM-DD HH:mm')
      this.subData(data)
    },
    // not ok 提交信息
    notOkHandle () {
      let data = JSON.parse(JSON.stringify(this.formData))
      let fillTimeAll = true
      if (!this.isAddTimeContent) {
        if (data.timeContent.length > 2) {
          data.timeContent.pop()
        }
      }
      data.timeContent.forEach(item => {
        if (!(item[0] && item[1] && !item[1].includes(''))) {
          fillTimeAll = false
        }
      })
      if (!fillTimeAll) {
        this.$zlr_message('All time must be selected', 'error')
        return false
      }
      data.content = []
      data.timeContent.forEach(item => {
        let date = dayjs(item[0]).format('YYYY-MM-DD')
        data.content.push({
          maxTimeStr: `${date} ${item[1][1]}`,
          minTimeStr: `${date} ${item[1][0]}`
        })
      })
      delete data.resultTimeStr
      this.subData(data)
    },
    // 提交数据
    subData (data) {
      delete data.timeContent
      delete data.isOk
      this.isSub = true
      data.appointmentTimeId = this.appointmentId
      subAppConfirm(data).then(res => {
        this.$zlr_message(subSuc, 'success')
        this.$emit('on-confirm-success')
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    },
    // 选择时区
    zoneChange () {
      this.selOkChange('')
      let zone = this.formData.mentorZone
      this.getAppTimeZone(zone).then(res => {
        this.zoneList = res
      })
    },
    // 获取学生时区
    getMenteeZone () {
      let menteeZone = this.appDetail.menteeZone
      this.getAppTimeZone(menteeZone).then(res => {
        this.menteeZoneList = res
      })
    },
    // 获取转换时间
    getAppTimeZone (zone) {
      return new Promise(resolve => {
        getAppTimeZone({
          zone,
          appointmentId: this.appointmentId
        }).then(res => {
          resolve(res.data.list)
        })
      })
    },
    // 选择ok或者not ok
    selOkChange (value) {
      this.$set(this.formData, 'isOK', value)
      this.resetData()
    },
    // 重置信息
    resetData () {
      this.$set(this.formData, 'resultTimeStrStart', '')
      this.$set(this.formData, 'resultTimeStrEnd', '')
      this.$set(this.formData, 'appointmentTimeId', '')
      this.$set(this.formData, 'timeContent', [[], [], []])
      this.expectRange = []
      this.errorMsg = ''
    },
    // 期望时间
    expectTimeHandle (item) {
      this.$set(this.expectRange, 0, item.minTimeStr)
      this.$set(this.expectRange, 1, item.maxTimeStr)
    },
    // 添加辅导时间时间段
    chanbgeAddTimeContent () {
      this.isAddTimeContent = !this.isAddTimeContent
      if (!this.isAddTimeContent) {
        this.formData.timeContent[2][0] = ''
        this.formData.timeContent[2][1] = ['', '']
      }
    }
  },
  watch: {
    appDetail (newValue) {
      this.getMenteeZone()
    },
    formData: {
      handler (data) {
        let progress0 = 0
        let progress1 = 0
        // 第一步
        if (data.mentorZone) {
          progress0 = 1
        }
        if (data.isOK === 0 || data.isOK === 1) {
          progress0 = 2
        }
        this.progress0 = (progress0 / 2) * 100
        // 第二步的
        if (data.isOK === 1) {

        } else if (data.isOK === 0) {
          data.timeContent.forEach(item => {
            if (item[0] && item[1] && !item[1].includes('')) {
              progress1++
            }
          })
          if (!this.isAddTimeContent) {
            progress1 = (progress1 / 2).toFixed(2) * 100
          } else {
            progress1 = (progress1 / 3).toFixed(2) * 100
          }
        }
        this.progress1 = progress1
      },
      deep: true
    }
  },
  filters: {
    addTwoDay (value) {
      return dayjs(value).add(2, 'day').format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
